const breakpoints = {
	'isDesktop': '(min-width: 869px)',
	'isMobile': '(max-width: 868.98px)'
}

export default breakpoints